// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HK5vknS1AnGXrd7rTTWu{width:100%;height:100%;display:flex;flex-direction:column}.HK5vknS1AnGXrd7rTTWu .W7XTfBkjxXhfeoJJZI7D{flex:1;display:flex;justify-content:center;align-items:center}.HK5vknS1AnGXrd7rTTWu .wQno9ftznkA73qNfOONl{width:100%;height:100%;display:flex;justify-content:center;align-items:center;position:relative}.HK5vknS1AnGXrd7rTTWu .qaH9Hx7fjjigi1JqvkGO{text-align:center;line-height:20px}.HK5vknS1AnGXrd7rTTWu .qaH9Hx7fjjigi1JqvkGO .UE4ohhdEDHi3jPxW98Kn{font-size:14px;color:#131a4f;margin:1rem 0 0 0;text-align:center}.HK5vknS1AnGXrd7rTTWu .qaH9Hx7fjjigi1JqvkGO .NrnH4R9Jw7Si351FNuyj{margin-top:0;font-size:14px;color:#8292b1}.HK5vknS1AnGXrd7rTTWu .qaH9Hx7fjjigi1JqvkGO .ecb6EWRPRV_JhIgb14jL{font-size:.7rem;font-style:italic;color:#6e32f0}.HK5vknS1AnGXrd7rTTWu .qaH9Hx7fjjigi1JqvkGO .ecb6EWRPRV_JhIgb14jL span{color:#8496b9}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"blockContainer": `HK5vknS1AnGXrd7rTTWu`,
	"content": `W7XTfBkjxXhfeoJJZI7D`,
	"contentElement": `wQno9ftznkA73qNfOONl`,
	"metadata": `qaH9Hx7fjjigi1JqvkGO`,
	"title": `UE4ohhdEDHi3jPxW98Kn`,
	"subtitle": `NrnH4R9Jw7Si351FNuyj`,
	"infoSrc": `ecb6EWRPRV_JhIgb14jL`
};
export default ___CSS_LOADER_EXPORT___;
